import { Component, Input, OnInit } from '@angular/core';
import { ANGULAR_MODULES } from '../../shared-imports';

@Component({
  standalone: true,
  selector: 'app-hourglass-spinner',
  imports:[ANGULAR_MODULES],
  templateUrl: './hourglass-spinner.component.html',
  styleUrls: ['./hourglass-spinner.component.scss']
})
export class HourglassSpinnerComponent implements OnInit{
  isLoading = true;
  @Input() loadHourGlassLoader;
  ngOnInit(): void {
    //this.isLoading = this.loadHourGlassLoader;
  }
}
